<template>
  <div class="home">
    <span>
      国家退堂鼓一级演员
      <br />国际鸽子拖延赛亚军
      <br />二刺螈，程序媛，底层画师，不会打光的建模新手
      <br />前影视行业混子，目前专精前端
      <br />满面白光刀客塔，十连全R痒痒鼠
      <br />巨神坑第一菜鸡辅助，OW各种模式垫底
      <br />可能我不适合打游戏吧
      <br />呜呜呜大佬教我画画！
    </span>
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style>
.home {
  height: 100%;
  display: flex;
  margin: auto 0;
  align-items: center;
}
.home span{
  color: #DC9495;
  font-size: 1.3rem;
  letter-spacing: 2px;
  line-height: 1.7rem;
}
</style>